import React, { useState, useEffect } from "react";
import "./Login.css";
import banner_img from "../../../images/banner-picture.png";
import login_logo from "../../../images/loginlogo.png";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { InputLabel, Input, InputAdornment, IconButton } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import { Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { userLoginApi } from "../../../Services/Login/LoginApi/loginApi";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CommunityOwner, HomeOwner, SuperAdmin } from "../../../Utils/Constant";
import chevronleft from "../../../images/chevronleft.svg";

function LoginComponent() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false); // Prevent multiple submissions
  const [showPassword, setShowPassword] = useState(false);
  const [rememberPassword, setRememberPassword] = useState(false);

  useEffect(() => {
    const accessToken = localStorage.getItem("access_token");
    const userType = localStorage.getItem("user_type");

    if (accessToken && userType) {
      switch (userType) {
        case CommunityOwner:
          navigate("/admin/Admin-community");
          break;
        // case SuperAdmin:
        //   navigate("/super-admin/dashboard");
        //   break;
        case HomeOwner:
          navigate("/home-owner-admin/home-owner-community");
          break;
        default:
          break;
      }
    }
  }, [navigate]);

  useEffect(() => {
    // Load saved password from local storage
    const savedPassword = localStorage.getItem("password");
    const savedEmail = localStorage.getItem("email");
    if (savedPassword && savedEmail) {
      setPassword(savedPassword);
      setEmail(savedEmail);
      setRememberPassword(true);
    }
  }, []);

  const handleRememberChange = (e) => {
    setRememberPassword(e.target.checked);
  };

  // Handler to toggle password visibility
  const handleClickShowPassword = () => {
    setShowPassword((prevState) => !prevState);
  };

  // Prevent default behavior for mouse down event
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSubmit(e);
    }
  };

  // Validation function
  const validateForm = () => {
    let formErrors = {};
    let isValid = true;

    if (!email) {
      formErrors.email = "Email is required.";
      isValid = false;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      formErrors.email = "Invalid email format.";
      isValid = false;
    }

    if (!password) {
      formErrors.password = "Password is required.";
      isValid = false;
    } else if (password.length < 6) {
      formErrors.password = "Password must be at least 6 characters long.";
      isValid = false;
    }

    setErrors(formErrors);
    return isValid;
  }; // Closing brace added here

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
    if (errors.email) {
      setErrors((prevErrors) => ({ ...prevErrors, email: "" }));
    }
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
    if (errors.password) {
      setErrors((prevErrors) => ({ ...prevErrors, password: "" }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const lowercasedEmail = email.toLowerCase();

    if (isSubmitting) return; // Prevent additional clicks
    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true); // Lock the button

    if (rememberPassword) {
      localStorage.setItem("password", password);
      localStorage.setItem("email", lowercasedEmail); 
    } else {
      localStorage.removeItem("password");
      localStorage.removeItem("email");
    }

    try {
      const response = await dispatch(
        userLoginApi({ email: lowercasedEmail, password })
      ).unwrap();

      if (response?.status === 200) {
        if (response.data?.user_type === SuperAdmin) {
          // Display an error or take no action for SuperAdmin
          toast.success("SuperAdmin login is not allowed.!");
          return; // Exit the function to stop further execution
        } else {
          // toast.success("Login successful!");
          localStorage.setItem("access_token", response.data.token?.access);
          localStorage.setItem("refresh-token", response.data.token?.refresh);
          localStorage.setItem("user_type", response.data?.user_type);
          localStorage.setItem("user_id", response.data?.user_id);
          localStorage.setItem("user_first_name", response.data?.first_name);
          localStorage.setItem("user_last_name", response.data?.last_name);

          if (response.data?.user_type === CommunityOwner) {
            setTimeout(() => {
              navigate("/admin/Admin-community");
            }, 500);
          } else if (response.data?.user_type === HomeOwner) {
            setTimeout(() => {
              navigate("/home-owner-admin/home-owner-community");
            }, 500);
          }
        }
      }
      if (response?.status === 202) {
        localStorage.setItem("access_token", response.data.token?.access);
        localStorage.setItem("refresh-token", response.data.token?.refresh);
        localStorage.setItem("user_type", response.data?.user_type);
        localStorage.setItem("user_id", response.data?.user_id);
        localStorage.setItem("user_first_name", response.data?.first_name);
        localStorage.setItem("user_last_name", response.data?.last_name);

        if (response.data?.user_type === CommunityOwner) {
          setTimeout(() => {
            navigate("/admin/Admin-community");
          }, 500);
        } else if (response.data?.user_type === HomeOwner) {
          setTimeout(() => {
            navigate("/home-owner-admin/home-owner-community");
          }, 500);
        }
        // toast.error(response?.message);
        // setTimeout(() => {
        //   navigate("/registered-email-verification", { state: { id: response?.data?.user_id, email: email } });
        // }, 1000);
      }
    } catch (err) {
      if (err?.status === 403) {
        toast.error(err?.message);
      } else {
        toast.error("Login failed: Email and Password invalid!");
      }
    } finally {
      setIsSubmitting(false); // Unlock the button
      setEmail(""); // Clear email input
      setPassword(""); // Clear password input
    }
  };

  // const [isSubmitting, setIsSubmitting] = useState(false); // Prevent multiple submissions
  // const [toastActive, setToastActive] = useState(false); // Prevent multiple toasts

  const handleSignuproute = () => {
    navigate("/signupone");
  };

  // const handleBackClick = () => {
  //   navigate("/");
  // };

  const label = { inputProps: { "aria-label": "Checkbox demo" } };

  return (
    <>
      <section className="login-page-one login-box">
        <div className="container-fluid p-0 m-0">
          <div className="row m-0 loginpage">
            <div className="col-md-6">
              <div className="login-right-block logo-left-block mb-0">
                <div className="login-logoimg text-center">
                  <Link to="/">
                    <img
                      src={login_logo}
                      alt="login-logo"
                      className="login_logo_img"
                    />
                  </Link>
                </div>
              </div>
              <div className="banner-contents">
                <div className="banner-image">
                  {/* <img src={banner_img} alt="banner-image" /> */}
                  <div className="text-overlay">
                    <h5>Welcome Back!</h5>
                    <p>
                      Elevate your business insights with precision. Log in to
                      discover and refine your Ideal Customer Profiles
                      effortlessly.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 login-cols-block">
              <div className="login-right-block desktop-view">
                <div className="login-logoimg text-center">
                  <Link to="/">
                    <img
                      src={login_logo}
                      alt="login-logo"
                      className="login_logo_img"
                    />
                  </Link>
                </div>
                {/* <div className="back-btn">
                  <a href="javascript:void(0)" onClick={handleBackClick}>
                    <img
                      src={chevronleft}
                      alt="chevron-left"
                      class="left-icon"
                    ></img>
                    Back
                  </a>
                </div> */}
              </div>
              <div className="login-page-area">
                <div className="login-information log-in">
                  {/* <h1 className="text-center">Log In</h1> */}
                  <div className="form-login text-left">
                    <div className="mb-4">
                      <InputLabel htmlFor="standard-adornment-email">
                        Email <span>*</span>
                      </InputLabel>
                      <Input
                        className="email-input-box"
                        id="standard-adornment-email"
                        type="email"
                        placeholder="Email"
                        onChange={handleEmailChange}
                        value={email}
                        onKeyDown={handleKeyDown}
                      />
                      {errors.email && (
                        <p className="error-text">{errors.email}</p>
                      )}
                    </div>
                    <div className="mb-4">
                      <InputLabel htmlFor="standard-adornment-password">
                        Password <span>*</span>
                      </InputLabel>
                      <Input
                        className="password-input-box"
                        id="standard-adornment-password"
                        placeholder="Password"
                        type={showPassword ? "text" : "password"}
                        onChange={handlePasswordChange}
                        value={password}
                        onKeyDown={handleKeyDown}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label={
                                showPassword
                                  ? "hide the password"
                                  : "display the password"
                              }
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                            >
                              {showPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                      {errors.password && (
                        <p className="error-text">{errors.password}</p>
                      )}
                    </div>
                    <div className="mb-4 checkbox d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center">
                        <div>
                          <Checkbox
                            {...label}
                            checked={rememberPassword}
                            onChange={handleRememberChange}
                            className="check-box"
                          />
                        </div>
                        <span className="password-text">Remember Password</span>
                      </div>
                      <div className="forgot-pw">
                        <Link to="/forgot-password">Forgot Password</Link>
                      </div>
                    </div>
                    <div className="btn-orange">
                      <Button onClick={handleSubmit} disabled={isSubmitting}>
                        {isSubmitting ? "Submitting..." : "Sign In"}
                      </Button>
                    </div>
                    <div className="lower-signup-text text-center">
                      <p>
                        Don&apos;t have an account?{" "}
                        <a href="" onClick={handleSignuproute}>
                          Sign Up
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ToastContainer />
    </>
  );
}

export default LoginComponent;
